var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isManager)?_c('div',{staticClass:"flex"},[_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('members'),"icon":"icon-users","route":"members"}}),_vm._v("\n   \n  "),_c('nested-menu-tab-button',{attrs:{"title":_vm.$t('import_members'),"icon":"icon-upload","route":"member.import"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }